exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.demo_days .v-input__slot {\n  background: #f7f7f8;\n  /* border: 1px solid #e4e5e7; */\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n}\n.demo_days .v-input__slot:focus {\n}\n", ""]);

// exports
